import {IState} from '../../../core/IState';
import {UnexpectedStateController} from '../controllers/unexpectedStateController';

export const UnexpectedState: IState = {
    name: 'unexpected',
    url: '/unexpected/{link}',    
    template: require('../templates/unexpected.html'),
    controller: UnexpectedStateController,
    controllerAs: 'vm',
    data: {
        title: 'Unexpected Error'
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unexpected/states/UnexpectedState.ts
 **/